//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  inheritAttrs: false,
  model: { prop: 'options' },
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      type: [String, Boolean, Array],
      required: false,
      default: false,
    },
    options: {
      type: [Array],
      required: false,
      default: () => [],
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      randomId: null,
    }
  },
  computed: {
    selected: {
      get() {
        return this.options
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    listeners() {
      const { input, ...rest } = this.$listeners

      return rest
    },
    checked() {
      return this.options.includes(this.value)
    },
    className() {
      const checkedState = this.options.includes(this.value)
        ? 'checked'
        : 'unchecked'

      return `form3-checkbox-${checkedState}-icon`
    },
    disabled() {
      return {}.propertyIsEnumerable.call(this.$attrs, 'disabled')
    },
  },
  mounted() {
    // Generate a random id to associate the input to the label
    this.randomId = (Math.random() + 1).toString(36).substring(7)
  },
}
